export const subjects = {
  SYSTEM_ACCESS: 'גישה למערכת',
  USER_INFORMATION: 'מידע של משתמש',
  USER_FILE: 'קבצי משתמש',
  RECEIPT: 'קבלה',
  TRANSFER: 'העברה',
  INVOICE: 'חשבונית',
  INVOICE_ORDER: 'הזמנת חשבונית',
  CUSTOMER: 'לקוח',
  PAYMENT: 'תשלום',
  PAYMENT_FILE: 'קובץ תשלומים',
  PARTNER: 'שותף',
  LAW_TRANSACTION: 'עסקאות',
}